import React, { FC } from 'react';

import { Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import LoadingAnimation from 'components/loading-animation';
import { RecentItemsCarousel } from 'components/recent-items-carousel';
import { ResponsiveCarouselWrapper } from 'components/responsive-carousel';
import useEffectOnce from 'hooks/use-effect-once';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { useRecentItemsAvailable } from 'hooks/use-recent-items-available';
import { useUniquePurchasedItems } from 'state/auth/hooks/use-unique-purchased-items';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';
import { relativeRoutes, routes } from 'utils/routing';

export const RecentItemsSection: FC<React.PropsWithChildren<unknown>> = () => {
  const { formatMessage } = useIntl();
  const { logEvent } = useMParticleContext();
  const isMobile = useIsMobileBreakpoint();
  const { loading } = useUniquePurchasedItems();
  const recentItemsAvailable = useRecentItemsAvailable();

  const locationName = 'Home page';

  useEffectOnce(() => {
    logEvent(CustomEventNames.RECENT_ITEMS_DISPLAYED, EventTypes.UserContent, {
      'User Location': locationName,
    });
  });

  const viewAllRedirect = isMobile ? `${routes.menu}/${relativeRoutes.recentItems}` : routes.orders;

  const header = formatMessage({ id: 'recentItems' });
  const recentItemsText = formatMessage({ id: 'viewAll' });
  const recentItemsAccessibilityLabel = formatMessage({ id: 'viewAllRecentItems' });

  return (
    <ResponsiveCarouselWrapper
      testID="recentItemsContainer"
      header={header}
      linkText={recentItemsText}
      linkPath={viewAllRedirect}
      linkAccessibilityLabel={recentItemsAccessibilityLabel}
      mt="$4"
      minHeight="$8"
    >
      {loading ? (
        <LoadingAnimation />
      ) : recentItemsAvailable ? (
        <RecentItemsCarousel containerHasTopPadding={false} locationName={locationName} />
      ) : (
        <Text paddingY={'$8'}>{formatMessage({ id: 'noRecentItemsHeader' })}</Text>
      )}
    </ResponsiveCarouselWrapper>
  );
};
